import { c as _c } from "react/compiler-runtime";
import { IcoDownload16 } from '@onefootprint/icons';
import { LinkButton, useObjectUrl } from '@onefootprint/ui';
import { saveAs } from 'file-saver';
import { useTranslation } from 'react-i18next';
export type FinraFieldProps = {
  base64Data: string;
};
const FinraField = t0 => {
  const $ = _c(3);
  const {
    base64Data
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    objectUrl
  } = useObjectUrl(base64Data);
  let t1;
  if ($[0] !== objectUrl || $[1] !== t) {
    t1 = objectUrl ? <LinkButton iconComponent={IcoDownload16} onClick={() => {
      saveAs(objectUrl);
    }}>{t(_temp)}</LinkButton> : <p className="text-body-2 text-primary fp-text">-</p>;
    $[0] = objectUrl;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default FinraField;
function _temp($) {
  return $.download;
}